import axios from 'axios'; // eslint-disable-line

export const updateProjectVersionViaApi = (projectVersionModel, projectId) => {
    return axios({
        url: `${window.GENESIS_CMS_API_URL}/v2/projects/${projectId}/updatelatest?sessionId=${localStorage.getItem('SessionId')}&token=${localStorage.getItem('AuthToken')}`,
        data: projectVersionModel,
        method: 'PUT',
    });
};

export const getLatestProjectVersionViaApi = (projectId) => { return axios.get(`${window.GENESIS_CMS_API_URL}/v2/projects/${projectId}/versions/latest?sessionId=${localStorage.getItem('SessionId')}&token=${localStorage.getItem('AuthToken')}`); };

export const deleteProjectViaApi = (projectId) => {
    return axios.delete(`${window.GENESIS_CMS_API_URL}/v2/projects/${projectId}`, {
        params: {
            sessionId: localStorage.getItem('SessionId'),
            token: localStorage.getItem('AuthToken'),
        },
    });
};
